import Item from './view'
import listComponent from '@/util/proto/listComponent'
import global from '@/util/mixin/global'

const AlarmTypePicker = {
  props:{
    value:''
  },
  data(){
    return {
      alarmTypeDict:[],
      defaultValue:[]
    }
  },
  created(){
    this.$request.batteryAlarmType().then( resp => {
      let data = this.$utils.tree(resp.data,'signalId','signalId').map(i => {
       return {
         value:i.signalId,
         label:i.signalName,
         children:i.children.map(j =>({
           value:j.alarmType+'@'+i.signalId,
           label:j.alarmDesc
         }))
       }
      })
      this.alarmTypeDict = data
    })

    this.$watch('value',function(nv) {
      if( nv ){
        let parent = nv.split('@')
        this.defaultValue = [parent,nv]
      }else{
        this.defaultValue = []
      }
    })
  },
  methods:{
    onChange(e){
      let val  = e.pop()
      this.$emit('input',val)
      this.$emit('change',val)
    }
  },
  render(){
    return <Cascader value={this.defaultValue} on-on-change={this.onChange}	data={this.alarmTypeDict} placeholder="告警类型" />
  }
}
export default {
  mixins:[global],
  extends: listComponent,
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 45,
          align: 'center',
          // fixed:'left',
        },
        {
          title: '告警时间',
          key: 'repostStartTimeText',
          minWidth: 160,
        },
        {
          title:'告警等级',
          key:'alarmLevelText',
          minWidth:160,
        },
        {
          title: '类型',
          key: 'alarmDesc',
          minWidth: 120,
        },
        {
          title: '车辆编号',
          key: 'carNo',
          minWidth: 130,
        },
        {
          title: '车架号',
          key: 'frameNo',
          minWidth: 130,
        },
        {
          title: '设备编号',
          key: 'imei',
          minWidth: 130,
        },
        {
          title: '所属企业',
          key: 'companyName',
          minWidth: 130,
        },
        {
          title: '操作',
          key: 'action',
          width: 180,
          align: 'center',
          fixed:'right',
          render: (h, {row}) => {
            let acts = []
            acts.push(<a on-click={()=>this.view(row)}>查看</a>)

            return this.$utils.link(acts,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      loading: false,

      params: {
        carNo:null,
        frameNo: null,
        imei: null,
        alarmLevel: null,
        alarmType:null,
        time:[]
      },
      alarmTypeDict:[]
    }
  },
  computed:{
  
  },
  created() {
    this.def = { ...this.params }
    
    this.search()
  },

  methods: {

    search() {
      let { time, alarmType,...search} = this.params
      if (time) {
        search.repostStartTime = time[0]
        search.repostEndTime = time[1]
      }

      if( alarmType ){
        let [newAlarmType,signalId] = alarmType.split('@')
        search.alarmType = newAlarmType
        search.signalId = signalId
      }
      let params = { search , pageSize:this.page.pageSize,pageNum: this.page.pageNum }

      this.loading = true
      this.$request.batteryAlarms(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 'alarmLevel': 'batteryAlarmLevel', 'repostStartTime': 'datetime','repostEndTime': 'datetime'})

          //站点 和 维修师都没分配，允许批量操作
          // for(let i of this.data){
          //   if( i.state != 0){
          //     i._disabled = true
          //   }
          // }
          this.page.total = resp.data.total || 0
        }
      })
    },

    view(row) {
      this.$refs['item'].init(row)
    },

    reset() {
      this.params = {}
      this.search()
    },

    handleUpdate() {
      this.search()
    }
  },
  render() {
    
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}>
            <sl-search-item label="">
              <i-input v-model={this.params.frameNo} placeholder="车架号" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.carNo} placeholder="车辆编号" />
            </sl-search-item>
            <sl-search-item label="">
              <i-input v-model={this.params.imei} placeholder="IMEI" />
            </sl-search-item>
            <sl-search-item label="">
              <AlarmTypePicker v-model={this.params.alarmType} />
            </sl-search-item>
            <sl-search-item>
              <DatePicker v-model={this.params.time} type="datetimerange" style="width:100%;" placeholder="请选择告警时间"></DatePicker>
            </sl-search-item>
            <sl-search-item>
              <sl-select v-model={this.params.alarmLevel} dict="batteryAlarmLevel" placeholder="告警等级" />
            </sl-search-item>
          </sl-search>
        </div>
        <div class="pg-bd">
          <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <Item ref="item" />
      </sl-page>
    )
  }
}